import { Routes } from '@/router/routes'
import { RouterContexts } from '@/router/RouterContexts'

import type { RouteLocationNormalized } from 'vue-router'

const guestRouterContexts = [
  RouterContexts.PORTAL_CONTEXT,
  RouterContexts.DAILY_AGENDA_CONTEXT,
]

const passwordResetComponent = () => import('@/features/password-reset/PasswordReset.vue')

export const authRoutes = [
  {
    name: Routes.Login,
    path: '/login',
    component: () => import('@/pages/contexts/portal/login/LoginPage.vue'),
    meta: {
      routerContexts: guestRouterContexts,
    },
  },
  {
    name: Routes.ForgotPassword,
    path: '/forgot-password',
    component: passwordResetComponent,
    props: {
      mode: 'request',
    },
    meta: {
      routerContexts: guestRouterContexts,
    },
  },
  {
    name: Routes.ResetPassword,
    path: '/reset-password/:token',
    component: passwordResetComponent,
    props: (route: RouteLocationNormalized) => ({
      mode: 'reset',
      token: typeof route.params.token === 'string' ? route.params.token : '',
      email: typeof route.query.email === 'string' ? route.query.email : '',
    }),
    meta: {
      routerContexts: guestRouterContexts,
    },
  },
]
